import React from "react";


export const getLocalToken = () => {
let token = localStorage.getItem(process.env.REACT_APP_AUTH_TOKEN_KEY);
return token;
}